import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentCoordinatesToggleValue } from '../../../../../../../../app/redux/slices/currentCoordinatesToggleValueSlice';
import CustomButton from '../../../../../../../common/Button/CustomButton/CustomButton';
import { currentCoordsToggleValueState } from '../../../../../../../../app/redux/retrievers/retrievers';
import { theme } from '../../../../../../../../core/theme/theme';

const MapCoordinatesToggleMenu = () => {
    const dispatch = useDispatch();
    const currentCoordsToggleValue = useSelector(currentCoordsToggleValueState);
    const handleToggle = (value: number) => {
        dispatch(setCurrentCoordinatesToggleValue(value));
    };

    const fontFamily = 'sans-serif';
    return (
        <div style={{ position: 'absolute', right: '45px', display: 'flex', gap: 2, zIndex: 400 }}>
            <CustomButton
                onClick={() => handleToggle(0)}
                color={currentCoordsToggleValue === 0 ? theme.colors.selected_color : theme.colors.default}
                fontFamily={fontFamily}
                textColor={currentCoordsToggleValue === 0 ? theme.colors.default : 'black'}
                width={70}
                text="LAT/LNG"
            />
            <CustomButton
                onClick={() => handleToggle(1)}
                color={currentCoordsToggleValue === 1 ? theme.colors.selected_color : theme.colors.default}
                fontFamily={fontFamily}
                textColor={currentCoordsToggleValue === 1 ? theme.colors.default : 'black'}
                text="DMS"
            />
            <CustomButton
                onClick={() => handleToggle(2)}
                color={currentCoordsToggleValue === 2 ? theme.colors.selected_color : theme.colors.default}
                fontFamily={fontFamily}
                textColor={currentCoordsToggleValue === 2 ? theme.colors.default : 'black'}
                text="UTM"
            />
        </div>
    );
};

export default MapCoordinatesToggleMenu;
